'use strict';

const fields = {
  email: {
    label: 'Email',
    name: 'email',
    template: '<email-form></email-form>'
  },
  // phone: {
  //   label: 'Booking notifications',
  //   name: 'phone',
  //   template: '<phone-form></phone-form>'
  // },
  price: {
    label: 'Hourly rate',
    name: 'price',
    template: '<price-form></price-form>'
  },

  photos: {
    label: 'Profile photos',
    name: 'photos',
    template: '<photos-form></photos-form>',
    loadingText: 'Uploading <span class="u-hidden-m-inline">from Facebook</span>'
  },
  name: {
    label: 'Name',
    name: 'name',
    template: '<name-form></name-form>'
  },
  languages: {
    label: 'Languages',
    name: 'languages',
    template: '<languages-form></languages-form>'
  },
  shortDescription: {
    label: 'Motto',
    name: 'shortDescription',
    template: '<short-description-form></short-description-form>'
  },
  aboutMe: {
    label: 'About me',
    name: 'aboutMe',
    template: '<about-me-form></about-me-form>'
  },
  location: {
    label: 'Location',
    name: 'location',
    template: '<location-form></location-form>'
  },
  tourDescription: {
    label: 'I will show you',
    name: 'tourDescription',
    template: '<tour-description-form></tour-description-form>'
  },
  activities: {
    label: 'Activities',
    name: 'activities',
    template: '<activities-form></activities-form>'
  }
};

const guideSettingsLayout = {
  layout : [
    {
      header: 'SETTINGS_SECTIONS.GENERAL',
      fields: [
        fields.name,
        fields.location,
        fields.photos,
        fields.languages,
        fields.aboutMe
      ]
    },
    {
      header: 'SETTINGS_SECTIONS.GUIDE',
      fields: [
        fields.shortDescription,
        fields.tourDescription,
        fields.activities,
        fields.price
      ]
    },
    {
      header: 'SETTINGS_SECTIONS.CONTACT',
      fields: [
        fields.email,
        //fields.phone
      ]
    }
  ],
  stepCount: 11,
};

export default function f() {
  return guideSettingsLayout;
}



// WEBPACK FOOTER //
// ./app/src/services/settings_layout_config.js